var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPauseArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_5795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0H1.5C0.671573 0 0 0.671573 0 1.5V20.5C0 21.3284 0.671573 22 1.5 22H5.5C6.32843 22 7 21.3284 7 20.5V1.5C7 0.671573 6.32843 0 5.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0H12.5C11.6716 0 11 0.671573 11 1.5V20.5C11 21.3284 11.6716 22 12.5 22H16.5C17.3284 22 18 21.3284 18 20.5V1.5C18 0.671573 17.3284 0 16.5 0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseArrow);
export default __webpack_public_path__ + "static/media/pause-arrow.4cd3e93b723dcdec7577ac53c2f96e26.svg";
export { ForwardRef as ReactComponent };